/** PNG icons under `public/assets/Mens wear/` */
const MENS_WEAR_ASSET_BASE = `${process.env.PUBLIC_URL || ''}/assets/Mens wear`;

function menWearIcon(filename) {
  return `${MENS_WEAR_ASSET_BASE}/${filename}`;
}

export const MEN_GARMENT_TYPE_ICON_BY_VALUE = {
  kurta: menWearIcon('Kurta.png'),
  shirt: menWearIcon('Shirt.png'),
  tshirt: menWearIcon('Tshirt.png'),
  trouser: menWearIcon('Trousers.png'),
  blazer: menWearIcon('Blazer.png'),
  // Case-sensitive on Linux/production. Git stores this as `jacket.png` (lowercase).
  jacket: menWearIcon('jacket.png'),
  waistcoat: menWearIcon('waistcoat.png'),
  'kurta-dhoti': menWearIcon('Dhoti.png'),
  pajama: menWearIcon('Payjama.png'),
  cordset: menWearIcon('Shirt.png'),
  socks: menWearIcon('socks.png'),
};

export function getMenGarmentTypeIcon(typeValue) {
  if (!typeValue) return null;
  return MEN_GARMENT_TYPE_ICON_BY_VALUE[typeValue] || null;
}
